import { prepareQueryParams } from '@homeviews/utils'
import { api, API_V2_BASE_URL } from '@homeviews/store'
import type { MetaTotal } from '@homeviews/analytics'

type AreaQueryParams = {
  // When true, get Areas only for authenticated user's Developments
  portalDevelopments?: boolean
  // When true, get only Areas that have an Area Guide
  areaGuide?: boolean
}

// https://redux-toolkit.js.org/rtk-query/usage/code-splitting
export const areasApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAreas: build.query<MetaTotal, AreaQueryParams>({
      query: (params: AreaQueryParams) => ({
        url: `${API_V2_BASE_URL}/areas${prepareQueryParams(params)}`,
        method: 'GET',
      }),
    }),
  }),
})

export const {
  // https://redux-toolkit.js.org/rtk-query/api/created-api/hooks#usequery
  useGetAreasQuery,
} = areasApi
